<div *ngIf="iterativeDataSource.length" style="position: relative; margin-top: 1.5em;">
    <div class="action-label">{{label | translate}}</div>
    <kt-portlet class="kt-portlet--bordered">
        <kt-portlet-body>
            <mat-accordion>
                <mat-expansion-panel *ngFor="let itemDataSource of iterativeDataSource">
                    <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
                        <mat-panel-title class="iterative-task-progress">
                            {{
                                'TRACING_PLAN_DETAIL.TABLE.ITERATIVE_TASK_PROGRESS'
                                | translate
                                | stringFormat: ( getIterativeTaskGroupProgress(itemDataSource.data) | percent: '1.0-0' )
                            }}
                        </mat-panel-title>
                        <mat-panel-description>
                            {{ itemDataSource.data[0].taskDescription }}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <!-- Tabla con tareas iterativas -->
                    <div class="iterative-tasks-table mobile-table-container">
                        <mat-table [dataSource]="itemDataSource" class="mobile-table">
                            <ng-container matColumnDef="assignedRole">
                                <mat-header-cell *matHeaderCellDef class="col-width-25">
                                    {{'TRACING_PLAN_DETAIL.TABLE.HEADER.ASSIGNED_ROLE' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="col-width-25">
                                    {{element.assignedRole}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="expirationDate">
                                <mat-header-cell *matHeaderCellDef class="col-width-30">
                                    {{'TRACING_PLAN_DETAIL.TABLE.HEADER.EXPIRATION_DATE' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="col-width-30">
                                    {{(element.expirationDate | date: 'dd/MM/yyyy') || ('TRACING_PLAN_DETAIL.NO_DATE' | translate) }}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="progressPercent">
                                <mat-header-cell *matHeaderCellDef class="col-width-25">
                                    {{'TRACING_PLAN_DETAIL.TABLE.HEADER.COMPLETED' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="col-width-25">
                                    <div *ngIf="((100 * element.progressPercent) | number: '1.0-0') == 100; then complete else incomplete"></div>
                                    <ng-template #complete><i class="material-icons md-24">check_box</i></ng-template>
                                    <ng-template #incomplete><i class="material-icons md-24">check_box_outline_blank</i></ng-template>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="lastActionDate">
                                <mat-header-cell *matHeaderCellDef class="col-width-25">
                                    {{'TRACING_PLAN_DETAIL.TABLE.HEADER.LAST_ACTION_DATE' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="col-width-25">
                                    {{(element.lastActionDate | date: 'dd/MM/yyyy') || ('TRACING_PLAN_DETAIL.NO_DATE' | translate) }}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef class="col-width-20">
                                    {{'TRACING_PLAN_DETAIL.TABLE.HEADER.ACTIONS' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" class="col-width-20">
                                    <button
                                    [matTooltip]="'TRACING_PLAN_DETAIL.TABLE.TOOLTIP.COMPLETE_TASK' | translate"
                                    mat-icon-button color="primary"
                                    class="medium"
                                    (click)="actionClicked.next(element)"
                                    >
                                        <i class="material-icons">forward</i>
                                    </button>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="noRecord">
                                <mat-footer-cell *matFooterCellDef>
                                    <div style="width: 100%;text-align: center;">{{'TRACING_PLAN_DETAIL.TABLE.EMPTY' | translate}}</div>
                                </mat-footer-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="iterativeTaskDisplayedColumns" style="padding: 0 1.5em 0 1.5em;"></mat-header-row>
                            <mat-row class="mobile-table-row" *matRowDef="let row; columns: iterativeTaskDisplayedColumns;" style="padding: 0 1.5em 0 1.5em;"></mat-row>

                            <mat-footer-row
                                *matFooterRowDef="['noRecord']"
                                [hidden]="itemDataSource.data.length > 0">
                            </mat-footer-row>
                        </mat-table>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </kt-portlet-body>
    </kt-portlet>
</div>